'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ATTACHMENT_UPLOAD_PROGRESS = exports.ATTACHMENT_UPLOAD_PROGRESS = 'ATTACHMENT_UPLOAD_PROGRESS';

var ATTACHMENT_UPLOAD_START = exports.ATTACHMENT_UPLOAD_START = 'ATTACHMENT_UPLOAD_START';

var ATTACHMENT_UPLOAD_COMPLETE = exports.ATTACHMENT_UPLOAD_COMPLETE = 'ATTACHMENT_UPLOAD_COMPLETE';

var REMOVE_ATTACHMENT = exports.REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT';

var CLEAR_ATTACHMENTS = exports.CLEAR_ATTACHMENTS = 'CLEAR_ATTACHMENTS';

var ASSOCIATE_ATTACHMENTS = exports.ASSOCIATE_ATTACHMENTS = 'ASSOCIATE_ATTACHMENTS';

var ATTACHMENT_ERROR = exports.ATTACHMENT_ERROR = 'ATTACHMENT_ERROR';

var DISMISS_ATTACHMENTS_ERROR = exports.DISMISS_ATTACHMENTS_ERROR = 'DISMISS_ATTACHMENTS_ERROR';


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/constants/fileUploadsActionTypes.js
// module id = 28
// module chunks = 2 3